/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface InvitationAcceptResponse {
  message: string;
  /**
     * @maxLength 50
     * @pattern ^org_[A-Za-z0-9]+$
     */
  workos_org_id: string;
}
